import React from "react";
import { cn } from "../lib/utils";

export const PageHeader = ({ title, subtitle, actions, className }) => (
  <div className={cn("flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between", className)}>
    <div className="min-w-0">
      <h1 className="truncate text-xl font-semibold tracking-tight sm:text-2xl" data-testid="page-title">
        {title}
      </h1>
      {subtitle ? <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p> : null}
    </div>
    {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);
